module.exports = __webpack_public_path__ + "img/Called-To-Rescue.ca7803bd.png";